export enum ErrorCode {
  EXPIRED_TOKEN_ERROR = 401,
  MANY_REQUEST_LIMIT_ERROR = 429
}

export enum ScheduleBillPayment {
  NOW = 'NOW',
  FUTURE = 'FUTURE',
  RECURRING = 'RECURRING'
}

export enum IntervalBillPayment {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY'
}

export enum DatePickerType {
  SCHEDULE_DATE_LATER = 'schedule_date_later',
  DATE_OF_FIRST_PAYMENT = 'date_of_first_payment',
  END_DATE_PAYMENT = 'end_date_payment'
}

export enum OtpConfirmType {
  GOOGLE_OTP = 'google_otp',
  SMS_OTP = 'sms_otp'
}

export enum OtpInput {
  MAX_LENGTH = 6
}

export enum HelpCenterLink {
  TYPE_OF_BILL_COVERAGE = 'https://help.utgl.io/en/articles/6954727-what-type-of-bills-are-covered-by-the-global-bill-payment-service',
  PAY_FOR_OTHER = 'https://help.utgl.io/en/articles/6954696-can-i-pay-for-other-people-s-bills-invoices',
  TRANSFER_NONE_WORKING_DAY = 'https://help.utgl.io/en/articles/6954705-what-happens-if-the-transfer-date-is-a-holiday-or-non-working-day',
  REQUEST_MUlTIPLE_BILL = 'https://help.utgl.io/en/articles/6954701-can-i-request-bill-payment-on-invoices-outside-hong-kong'
}

export enum OtpVerifyType {
  GOOGLE_OTP = 1,
  SMS_OTP = 2
}

export enum UnionType {
  PAYMENT = 'PAYMENT',
  ACCOUNT = 'ACCOUNT'
}
